import { StateActionTypes } from "../types/enums";

export const stakesHandlers: ReducerHandlers = {
  [StateActionTypes.UPDATE_SINGLE_STAKE]: (state) => state,

  [StateActionTypes.UPDATE_GLOBAL_STAKE]: (state) => state,
};
